module.exports = __webpack_public_path__ + "img/Friends_Testament_Spanish_1_2_2.png";